import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
  styled,
  ButtonBase,
  Grid,
  Divider,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Switch,
} from "@mui/material";

import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Services from "./Services";
import ConnectionDetails from "./CreateConnection/ConnectionDetails";
import UserConnectionStatus from "./UserConnectionStatus";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { revokeAllConnections } from "../../../APICalling/ServiceAPICalling";
import { deleteSettingById } from "../../../APICalling/OtherCalling";
import { EXTENSION_IDENTIFIER } from "../../../config/serviceConstant";
import { getOpenSnakSuccessData } from "../../../config/otherConstant";
const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const label = { inputProps: { "aria-label": "Switch demo" } };
function ConnectionDetailsView({
  setConnection,
  dataCenter,
  orgId,
  apiKey,
  zApiKey,
  setSnack,
  handlefetchConnections,
  dataCenterUrl,
  activeUsers,
  currentUser,
  connectionDetails,
  setConnectionDetails,
}) {
  const [service, setService] = useState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [credentialOfLoginUser, setCredentialOfLoginUser] =
    React.useState(true);

  const handleDeleteDialogOpen = () => {
    setOpenDeleteDialog(true);
    handleClose();
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
  };

  const handleRevokeAll = async () => {
    try {
      const headers = {
        connname: `${connectionDetails?.service?.serviceConnection}__${connectionDetails?.data?.connApiName}`,
        orgid: orgId,
        apikey: apiKey,
      };
      const revokeConnectionsResp = await revokeAllConnections({ headers });
      console.log({ revokeConnectionsResp });
      setSnack(getOpenSnakSuccessData("All connections revoked successfully"));
    } catch (error) {
      console.log({ error });
    }
    handlefetchConnections()
  };

  const handleRevokeAndDeleteConnection = async () => {
    try {
      const headers = {
        connname: EXTENSION_IDENTIFIER,
        orgid: orgId,
        apikey: apiKey,
      };
      const deleteResp = await deleteSettingById({
        headers,
        settingId: connectionDetails?.settingId,
      });
      await handleRevokeAll();
      
      setSnack(getOpenSnakSuccessData("Setting deleted successfully"));
    } catch (error) {}
  };

  const handleDialogOpen = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleEditClick = (e) => {
    setIsFilterOpen((prev) => !prev);
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setIsFilterOpen(false);
    setAnchorEl(null);
  };

  return (
    <Box p={5}>
      <Grid container spacing={2} pb={3}>
        <Grid item xs={2} mr={4} sx={{ display: "flex" }}>
          <ArrowBackIosIcon
            sx={{ color: "#757575", "&:hover": { color: "black" }, pt: 1.3 }}
            onClick={() => setConnection((prev) => "list")}
          />
          <Box>
            <Typography sx={{ fontWeight: "bold", fontSize: "19px" }}>
              {`${
                connectionDetails?.service?.serviceConnection?.split("__")?.[1]
              }__${connectionDetails?.data?.connName}`}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            sx={{
              display: "flex",
              pl: {
                xl: 0,
                md: 20,
              },
            }}
          >
            <Box>
              <Button
                onClick={handleDialogOpen}
                sx={{
                  bgcolor: "#E69D26",
                  color: "white",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "#FA9D26", // Keep the same background color on hover
                  },
                }}
              >
                <DoNotDisturbAltIcon
                  sx={{ pr: 0.4, width: "17px", height: "17px" }}
                />
                Revoke
              </Button>
            </Box>
            <Box>
              <Button
                onClick={handleDeleteDialogOpen}
                sx={{
                  bgcolor: "#ff0000",
                  color: "white",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "#AA0000", // Keep the same background color on hover
                  },
                }}
              >
                <DeleteIcon
                  sx={{ pr: 0.4, width: "17px", height: "17px" }}
                />
                Delete
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <Box mt={5} pb={3}>
        <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
          Connection Summary
        </Typography>
        <Box
          sx={{
            display: {
              lg: "flex",
              md: "block",
            },
          }}
        >
          <Box width={"30%"} mt={3}>
            <Typography sx={{ color: "#777777", fontSize: "15px" }}>
              Connection Name
            </Typography>
            <Typography sx={{ fontSize: "15px" }}>
              {connectionDetails?.data?.connName}
            </Typography>
          </Box>
          <Box mt={3}>
            <Typography sx={{ color: "#777777", fontSize: "15px" }}>
              Service Name
            </Typography>
            <Typography sx={{ fontSize: "15px" }}>
              {connectionDetails?.service?.name}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: {
              lg: "flex",
              md: "block",
            },
          }}
        >
          <Box width={"30%"} mt={3}>
            <Typography sx={{ color: "#777777", fontSize: "15px" }}>
              Scopes
            </Typography>

            {connectionDetails?.data?.scopes.map((data) => {
              console.log(data);
              return (
                <Typography sx={{ fontSize: "15px" }}>
                  {data?.scope?.name}
                </Typography>
              );
            })}
          </Box>
          <Box mt={3}>
            <Typography sx={{ color: "#777777", fontSize: "15px" }}>
              Logged In User Status
            </Typography>
            <Box sx={{ display: "flex" }}>
              {connectionDetails?.users?.find(
                (user) => user === currentUser?.email
              ) ? (
                <>
                  <FiberManualRecordIcon
                    sx={{
                      color: "#24D755",
                    }}
                  />

                  <Typography sx={{ fontSize: "15px", pt: 0.4 }}>
                    Connected
                  </Typography>
                </>
              ) : (
                <>
                  <FiberManualRecordIcon
                    sx={{
                      color: "#FF0000",
                    }}
                  />

                  <Typography sx={{ fontSize: "15px", pt: 0.4 }}>
                    Not Connected
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Box>
        
      </Box>
      <Grid mt={3} container item direction="column" spacing={2}>
        <UserConnectionStatus
          connectionDetails={connectionDetails}
          setConnectionDetails={setConnectionDetails}
          activeUsers={activeUsers}
          currentUser={currentUser}
          orgId={orgId}
          apiKey={apiKey}
          zApiKey={zApiKey}
          dataCenterUrl={dataCenterUrl}
          dataCenter={dataCenter}
          handlefetchConnections={handlefetchConnections}
          setSnack={setSnack}
        />
      </Grid>

      <Dialog
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box p={1}>
          <DialogTitle id="alert-dialog-title">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <DoNotDisturbAltIcon
                sx={{
                  color: "#E69D26",
                  bgcolor: "#FAF2E5",
                  p: 2,
                  borderRadius: "50%",
                }}
              />
              <Typography mt={3} sx={{ fontWeight: "bold" }}>
                Revoke Connection
              </Typography>
            </Box>
            <Divider sx={{ mt: 2 }} />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box
                mt={6}
                sx={{
                  maxWidth: "280px",
                  border: "1px dashed #EDEDED", // 2px dotted border with your preferred color
                  padding: 2, // Optional: Add padding to give space inside the box
                  borderRadius: 1, // Optional: Add a bit of rounding to the corners
                }}
              >
                <Typography sx={{ color: "black", fontSize: "16px" }}>
                  {`${
                    connectionDetails?.service?.serviceConnection?.split(
                      "__"
                    )?.[1]
                  }__${connectionDetails?.data?.connName}`}
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  {`${
                    connectionDetails?.service?.serviceConnection?.split(
                      "__"
                    )?.[1]
                  }__${connectionDetails?.data?.connName}`}
                </Typography>
              </Box>
              <Box
                mt={3}
                sx={{
                  bgcolor: "#F7F7F7",
                  maxWidth: "280px",
                  border: "1px dashed #EDEDED", // 2px dotted border with your preferred color
                  padding: 2, // Optional: Add padding to give space inside the box
                  borderRadius: 1, // Optional: Add a bit of rounding to the corners
                }}
              >
                <Typography mb={1} sx={{ color: "black", fontSize: "14px" }}>
                  Note
                </Typography>
                <Typography sx={{ color: "black", fontSize: "14px" }}>
                  Revoking the access permission of the connected causes the
                  execution of the Deluge functions that use this connection to
                  fail.
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleRevokeAll}
              sx={{
                bgcolor: "#E69D26",
                color: "white",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#E69D26",
                },
              }}
            >
              Revoke
            </Button>
            <Button
              onClick={handleDialogClose}
              sx={{
                textTransform: "none",
                color: "gray",
                "&:hover": {
                  color: "black",
                },
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          <Box display="flex" justifyContent="center" alignItems="center">
            <IconButton>
              <DeleteIcon sx={{ fontSize: 40, color: "red" }} />
            </IconButton>
          </Box>
          <Typography align="center" fontWeight="bold" fontSize="18px">
            Delete Connection
          </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="delete-dialog-description" align="center">
            Are you sure you want to delete this connection?
          </DialogContentText>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 2,
              mb: 2,
              padding: 1,
              border: "1px dashed #ccc",
            }}
          >
            <DeleteIcon sx={{ fontSize: 30, mb: 1 }} />
            <Typography variant="h6">
              {`${
                connectionDetails?.service?.serviceConnection?.split("__")?.[1]
              }__${connectionDetails?.data?.connName}`}
            </Typography>
            <Typography variant="caption">
              {`${
                connectionDetails?.service?.serviceConnection?.split("__")?.[1]
              }__${connectionDetails?.data?.connName}`}
            </Typography>
          </Box>

          <Box
            sx={{
              backgroundColor: "#f8f8f8",
              padding: 2,
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" fontWeight="bold">
              Note
            </Typography>
            <Typography variant="body2">
              Deleting may cause all the Deluge functions that use this
              connection to fail.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={async () => {
              await handleRevokeAndDeleteConnection();
              handleDeleteDialogClose();
            }}
            variant="contained"
            color="error"
          >
            Yes, Delete
          </Button>
          <Button
            onClick={handleDeleteDialogClose}
            variant="outlined"
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ConnectionDetailsView;
